export const state = {
  showroomDetails: {
    // Modify this here and backend since this value will be picked from authenticated user.
    // creator: "61f7d0bd60dfeb58a9808f86",
    // accountId: "6297c4539db81b975657b125",
  },
};
